import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioCultura from './FormularioCultura'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarCultura = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [cultura, setCultura] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarCulturaID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setCultura(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Cultura</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Cultura</Titulo>
                        <BtnRegresar ruta="/culturas"/>
                </Header>

                <FormularioCultura  cultura={cultura}/>
            </>
        );
    }
}
 
export default withRouter(EditarCultura);